export const SET_VALUES = 'SAMPLE_MAINTENANCE_SET_VALUES';

export const setValues = (values) => ({ type: SET_VALUES, values });
